export default "__VITE_ASSET__Uozo04KP__"